let root;

try {
    global; // If not in a node.js context global will throw a ReferenceError
    root = global;
} catch (e) {
    root = window;
}

export default root;
